/**
 * Excel export of the polling page's meter list: every meter matching the search and filters (not only
 * the loaded page). eleena-home builds the xlsx (GET /api/v2/meters/export), this only downloads it.
 */

import { fetchResponse } from '@/util/fetch'
import { READINGS_API_BASE, meterListParams } from '@/components/Polling/api'

/**
 * @param {{ query?: string, filters: object }} search
 * @returns {Promise<{ count: number, truncated: boolean }>}
 */
export async function exportMeters({ query, filters }) {
  const params = meterListParams(filters, query ? { query } : {})
  const response = await fetchResponse(`${READINGS_API_BASE}/meters/export?${params}`)
  if (!response.ok) {
    const body = await response.json().catch(() => ({}))
    throw new Error(body.message || body.detail || `${response.status} ${response.statusText}`)
  }

  const blob = await response.blob()
  const filename = /filename="([^"]+)"/.exec(response.headers.get('content-disposition') ?? '')?.[1]
    ?? `meters-${new Date().toISOString().slice(0, 10)}.xlsx`
  const url = window.URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.click()
  window.URL.revokeObjectURL(url)

  return {
    count: Number(response.headers.get('x-export-count') ?? 0),
    truncated: response.headers.get('x-export-truncated') === 'true',
  }
}
